import globalRoutes from '@/utils/globalRoutes'
import { Connection } from '@/plugins/conversationWebsocket'
import { NotificationModel } from '@/models/notification'

let host = globalRoutes.api?.replace('http', 'ws')

let connection = null
let events = {}

export const notificationEventEnums = {
  CREATE: 'notifications:create',
  UPDATE: 'notifications:update',
  DELETE: 'notifications:delete',
  BULK_READ: 'notifications:bulk_read',
  BULK_CLEAR: 'notifications:bulk_clear',
  META: 'notifications:meta'
}

const runEvents = (eventName, data) => {
  if (events[eventName]) {
    events[eventName].forEach((callback) => callback(data))
  }
}

const sendToken = ({ token }) => {
  connection.request('token', token)
  connection.setRoom(`notifications`)
}

export default {
  connect({ token }) {
    events = {}

    connection = new Connection(`${host}/api/pwa/ws`)

    connection.on('_reopen', () => sendToken({ token }))
    connection.on('_open', () => sendToken({ token }))

    connection.on('notificationCreate', ({ notification }) => {
      runEvents(notificationEventEnums.CREATE, {
        notification: NotificationModel.parseFromApi({ notification })
      })
    })
    connection.on('notificationUpdate', ({ notification }) => {
      runEvents(notificationEventEnums.UPDATE, {
        notification: NotificationModel.parseFromApi({ notification })
      })
    })
    connection.on('notificationDelete', ({ notificationId }) => {
      runEvents(notificationEventEnums.DELETE, { notificationId })
    })

    connection.on('notificationReadUpdate', ({ notificationIdList, isRead }) => {
      runEvents(notificationEventEnums.BULK_READ, { notificationIdList, isRead })
    })
    connection.on('notificationClearUpdate', ({ notificationIdList, isCleared }) => {
      runEvents(notificationEventEnums.BULK_CLEAR, { notificationIdList, isCleared })
    })

    connection.on('notificationMetaUpdate', ({ meta }) => {
      runEvents(notificationEventEnums.META, { meta })
    })
  },
  destroy() {
    if (connection) {
      connection.close()
    }
    events = {}
  },
  trigger(name, data) {
    runEvents(name, data)
  },
  addEvent(name, callback) {
    if (events[name]) {
      events[name].push(callback)
    } else {
      events[name] = [callback]
    }
  },
  removeEvent(name, callback) {
    if (events[name]) {
      events[name].splice(events[name].indexOf(callback), 1)
    }
    if (events[name]?.length === 0) {
      delete events[name]
    }
  },

  enums: notificationEventEnums,

  connection() {
    return connection
  }
}
